module.exports = { src: __webpack_public_path__ + "media/warm.a755e61c.svg", width: 229, height: 218 };